import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  consentTitle: {
    defaultMessage: '{clientName} uses Tink to connect to your bank',
    id: 'ConsentScreen.consentTitle',
  },
  consentInstruction: {
    defaultMessage: 'You will be asked to log in to your bank through a secure connection.',
    id: 'ConsentScreen.consentInstruction',
  },
  consentInformation: {
    defaultMessage:
      '{clientName} will retrieve the financial data required to provide this service.',
    id: 'ConsentScreen.consentInformation',
  },
  consentDetails: {
    defaultMessage: 'Tink will share your financial data with {clientName}. ',
    id: 'ConsentScreen.consentDetails',
  },
  aboutData: {
    defaultMessage: 'About your data',
    id: 'ConsentScreen.aboutData',
  },
  riskConsentTitle: {
    defaultMessage: '{clientName} uses Tink to connect to your bank',
    id: 'ConsentView.riskConsentTitle',
  },
  riskConsentDetails: {
    defaultMessage: '{clientName}, Tink, and their partners may access and use your personal data.',
    id: 'ConsentView.riskConsentDetails',
  },
  riskConsentTermsAndConditions: {
    defaultMessage:
      "Tink will access your personal data in accordance with Tink's {termsAndConditions} and {privacyPolicy}.",
    id: 'ConsentView.riskConsentTermsAndConditions',
  },
  riskConsentFinancesTitle: {
    defaultMessage: '{clientName} uses Tink to check your finances',
    id: 'ConsentView.riskConsentFinancesTitle',
  },
  riskConsentFinancesDetails: {
    defaultMessage: '{clientName} will gain access to your financial data.',
    id: 'ConsentView.riskConsentFinancesDetails',
  },
  riskConsentTermsAndConditionsDefault: {
    defaultMessage:
      'By selecting "Continue" you agree to Tink\'s {termsAndConditions} and {privacyPolicy}',
    id: 'ConsentView.riskConsentTermsAndConditionsDefault',
  },
});
